module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "okText": "确认",
      "cancelText": "取消",
      "afterClose": _vm.afterClose,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      },
      "ok": _vm.handleSubmit
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form
    }
  }, [_c('h5', [_vm._v("场景名称")]), _vm._v(" "), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['sceneName', {
        rules: [{
          required: true,
          message: '请输入场景名称'
        }]
      }]),
      expression: "['sceneName', { rules: [{ required: true, message: '请输入场景名称' }] }]"
    }]
  })], 1), _vm._v(" "), _c('h5', [_vm._v("上传封面图")]), _vm._v(" "), _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileListCover
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'cover'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("上传预览图")]), _vm._v(" "), _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileListPreview
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'preview'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("全景图类型")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.imageType),
      callback: function($$v) {
        _vm.imageType = $$v
      },
      expression: "imageType"
    }
  }, _vm._l((_vm.imageTypeOptions), function(option) {
    return _c('a-select-option', {
      key: option.id,
      attrs: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 1), _vm._v(" "), _c('h5', [_vm._v("上传全景图")]), _vm._v(" "), (_vm.imageType === 1) ? _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileList
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'image'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1) : _c('a-row', {
    attrs: {
      "type": "flex"
    }
  }, _vm._l((_vm.uploadItems), function(item, index) {
    return _c('a-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "upload-item"
    }, [_c('a-upload', {
      attrs: {
        "multiple": false,
        "data": _vm.typeParams,
        "listType": "picture-card",
        "action": _vm.$api.uploadUrl2,
        "headers": _vm.headers,
        "showUploadList": false,
        "before-upload": function (e) { return _vm.beforeUpload(e, item); }
      },
      on: {
        "preview": _vm.handlePreview,
        "remove": _vm.handleRemove,
        "change": function (e) { return _vm.handleChange(e, 'image', index); }
      }
    }, [(item.path) ? _c('div', {
      staticClass: "upload-img-wrapper",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('img', {
      staticClass: "image-pic",
      attrs: {
        "src": item.path
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-img-view"
    }, [_c('div', {
      staticClass: "ant-upload-list-item-actions-bg"
    }), _vm._v(" "), _c('div', {
      staticClass: "ant-upload-list-item-actions"
    }, [_c('a-icon', {
      staticClass: "upload-control-icon",
      attrs: {
        "type": "eye"
      },
      on: {
        "click": function($event) {
          return _vm.handlePreview(item.path)
        }
      }
    }), _vm._v(" "), _c('a-icon', {
      staticClass: "upload-control-icon",
      attrs: {
        "type": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    })], 1)])]) : _c('div', [_c('a-icon', {
      attrs: {
        "type": item.loading ? 'loading' : 'plus'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ant-upload-text"
    }, [_vm._v("上传")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "upload-item-text"
    }, [_vm._v(_vm._s(item.name))])], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "visible": _vm.previewVisible,
      "footer": null,
      "width": "800px"
    },
    on: {
      "cancel": function($event) {
        _vm.previewVisible = false
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "example",
      "src": _vm.previewImage
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be2b6bae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/AddScene.vue
// module id = 1077
// module chunks = 1